module.exports = __webpack_public_path__ + "media/images/footer-image-cfe0b670.jpg";